import { StatusBar } from 'expo-status-bar';
import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import styled from 'styled-components/native';

import { AppProvider } from './AppContext';
import UpdateChecker from './components/UpdateChecker';
import { DeviceSyncProvider } from './context/DeviceSyncContext';
import { SessionProvider } from './context/SessionContext';
import { UserProvider } from './context/UserContext';
import Navigation from './navigation';
import ErrorBoundary from './components/error-boundary/ErrorBoundary';
import { KeyboardProvider } from 'react-native-keyboard-controller';

const StyledAppView = styled.View`
  width: 100%;
  height: 100%;
  word-break: break-word;
  /* margin: auto; */
  /* box-shadow: 0px 8px 8px rgba(50, 50, 71, 0.2); */
`;
const AppLazy: React.FC = () => {
  return (
    <KeyboardProvider>
      <SafeAreaProvider>
        <ErrorBoundary>
          <AppProvider>
            <UpdateChecker />
            <UserProvider>
              <SessionProvider connect>
                <DeviceSyncProvider>
                  <StyledAppView>
                    <Navigation />
                    <StatusBar />
                  </StyledAppView>
                </DeviceSyncProvider>
              </SessionProvider>
            </UserProvider>
          </AppProvider>
        </ErrorBoundary>
      </SafeAreaProvider>
    </KeyboardProvider>
  );
};

export default AppLazy;
